import React from 'react';

const TravelReadyCenter = ({ width, height, fill, ...rest }) => {
    return (
        <svg
            {...rest}
            width={width || '24px'}
            height={height || '24px'}
            viewBox="0 0 24 24"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink">
            <defs>
                <polygon
                    id="path-digital-24"
                    points="0 0 21 0 21 24 0 24"></polygon>
            </defs>
            <g
                id="X-Global-Icons/Digital/travel-ready-center"
                stroke="none"
                stroke-width="1"
                fill="none"
                fillRule="evenodd">
                <g id="Group-3" transform="translate(1.500000, 0.000000)">
                    <mask id="mask-icon-trc" fill="white">
                        <use xlinkHref="#path-digital-24"></use>
                    </mask>
                    <g id="Clip-2"></g>
                    <g
                        id="Group-8"
                        mask="url(#mask-icon-trc)"
                        fill={fill || '#002244'}
                        fillRule="nonzero">
                        <g transform="translate(-0.000014, 0.000000)">
                            <path
                                d="M15,6.2625 L15,0 L0.6,0 C0.2625,0 0,0.2625 0,0.6 L0,23.4 C0,23.7375 0.2625,24 0.6,24 L20.4,24 C20.7375,24 21,23.7375 21,23.4 L21,6.75 L15.6,6.75 C15.3,6.75 15.075,6.525 15,6.2625 Z M7.5,4.5 L12,4.5 C12.3375,4.5 12.75,4.8375 12.75,5.25 C12.75,5.6625 12.3375,6 12,6 L7.5,6 C7.0875,6 6.75,5.625 6.75,5.25 C6.75,4.8375 7.1625,4.5 7.5,4.5 Z M2.5125,4.65 C2.7375,4.4625 3.1125,4.5 3.3,4.725 L3.7125,5.2125 L4.9875,3.2625 C5.1375,3 5.5125,2.925 5.775,3.1125 C6.0375,3.2625 6.1125,3.6375 5.925,3.9 L4.2375,6.525 C4.125,6.675 3.975,6.7875 3.7875,6.7875 C3.7875,6.7875 3.75,6.7875 3.75,6.7875 C3.6,6.7875 3.4125,6.7125 3.3,6.6 L2.4,5.4375 C2.2125,5.2125 2.25,4.8375 2.5125,4.65 Z M3.7875,12 C3.7875,12 3.75,12 3.7875,12 C3.6,12 3.4125,11.925 3.3375,11.8125 L2.4,10.6875 C2.2125,10.4625 2.25,10.0875 2.475,9.9 C2.7,9.7125 3.075,9.75 3.2625,9.975 L3.675,10.4625 L4.95,8.5125 C5.1,8.25 5.475,8.175 5.7375,8.3625 C6,8.5125 6.075,8.8875 5.8875,9.15 L4.2,11.775 C4.125,11.8875 3.975,12 3.7875,12 Z M16.425,14.7 C16.6125,15.075 16.425,15.525 16.05,15.7125 L12.525,17.3625 C12.525,17.3625 12.525,17.4 12.525,17.4 L10.575,21.375 C10.575,21.4125 10.5375,21.4125 10.5,21.45 L9.9,21.75 C9.825,21.7875 9.7125,21.7125 9.75,21.6 L10.1625,18.4875 C10.1625,18.4875 10.1625,18.45 10.1625,18.45 L6.525,20.2125 C6.4125,20.25 6.3,20.2875 6.1875,20.2875 C6.075,20.2875 6,20.25 5.8875,20.2125 C5.7,20.1375 5.55,19.95 5.475,19.7625 L4.5,16.7625 C4.3875,16.3875 4.575,15.9375 4.9875,15.825 C5.3625,15.7125 5.8125,15.9 5.925,16.3125 L6.6375,18.4875 L9.4125,17.175 C9.4125,17.175 9.4125,17.175 9.4125,17.175 L7.5,15.45 C7.425,15.375 7.4625,15.2625 7.5375,15.225 L8.175,15.0375 C8.2125,15.0375 8.2125,15.0375 8.25,15.0375 L11.8875,15.975 C11.8875,15.975 11.925,15.975 11.925,16.0125 L15.375,14.4 C15.7875,14.175 16.2375,14.325 16.425,14.7 Z M15.825,11.25 L7.4625,11.25 L7.3875,11.25 C7.125,11.2125 6.75,10.875 6.75,10.5 C6.75,10.0875 7.1625,9.75 7.4625,9.75 L15.825,9.75 C16.125,9.75 16.5,10.0875 16.5,10.5 C16.5,10.9125 16.125,11.25 15.825,11.25 Z"
                                id="Shape"></path>
                            <polygon
                                id="Path"
                                points="21 5.25 16.5 0 16.5 5.25"></polygon>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default TravelReadyCenter;
